// Import Actions
import { SET_CORRECTIONS, SET_SESSION_CORRECTIONS } from './CorrectionActions';
import { SET_IS_FETCHING } from '../App/AppActions';
import { LOGOUT_USER } from '../User/AuthActions';

// Initial State
export const initialState = {
    byApplicant: {},
    bySession: {},
    isFetching: false,
};

const InstitutionReducer = (state = initialState, action = {}) => {
    switch(action.type) {
        case SET_CORRECTIONS:
            return {
                ...state,
                byApplicant: {
                    ...state.byApplicant,
                    [action.applicantId]: action.corrections,
                },
                isFetching: false,
            };

        case SET_SESSION_CORRECTIONS:
            return {
                ...state,
                bySession: {
                    ...state.bySession,
                    [action.sessionId]: action.corrections,
                },
                isFetching: false,
            };

        case SET_IS_FETCHING:
            if(action.dataType === 'institutions') {
                return {
                    ...state,
                    isFetching: action.isFetching,
                };
            }
            return state;

        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
};

export default InstitutionReducer;
